import { IProductWithSerialNumber } from '../../../contracts/product-with-serial-number.js';

export class UnsupportedProductType extends TypeError {
  constructor(product: IProductWithSerialNumber) {
    super(`unsupported product type {${product.constructor.name}}.`);
  }
}
